<template>
    <v-list-item v-if="reply.field_options.length">
        <v-list-item-content>
            <v-list-item-subtitle>{{ reply.field.title }}</v-list-item-subtitle>
            <v-row dense>
                <v-col
                        dense
                        cols="12">
                    <ul>
                        <li
                                v-for="(option, optionKey) in optionsToDisplay"
                                :key="optionKey">
                            {{ option.field_option.value }}
                        </li>
                    </ul>
                </v-col>
            </v-row>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    export default {
        name: "FieldOptionsReply",
        props: {
            reply: {type: Object, default: () => {}}
        },
        computed: {
            optionsToDisplay() {
                return this.reply.field_options.filter(f => f.field_option !== null)
            }
        }
    }
</script>

<style scoped>

</style>